import axios from 'axios';
import qs from 'qs';

const urlParams = window.location.search;

const createBuyerEvent = (buyerProfileKey, category, action, value) => {
  const url = `${process.env.VUE_APP_API_URL}/BuyerREST/buyer-event/${buyerProfileKey}`;

  return axios.post(url, qs.stringify({
    eventsource: urlParams || 'PropertyNetwork',
    eventcategory: category,
    eventaction: action,
    eventvalue: value,
  }))
    .then(res => true)
    .catch((error) => {
      console.log(error);
      return false;
    });
};

export default { createBuyerEvent };
